module.exports = __webpack_public_path__ + "img/device-test-example.5b82895a.png";